module.exports = __webpack_public_path__ + "static/media/thinking-boy.9bbe4679.png";